import * as axios from './Axios'

const PREFIX = 'booking'

export const _createQuote = data => axios.post(`${PREFIX}/get-quote`, data)

export const _createBooking = data => axios.post(`${PREFIX}/create`, data)

export const _bookByQr = (id,data) => axios.post(`book-by-qr/${id}`, data)
export const _editBooking = (id,data) => axios.post(`${PREFIX}/${id}/edit`, data)

export const _list = () => axios.get(`${PREFIX}/list`)


export const _avgETA = () => axios.get(`${PREFIX}/avg-eta`);
